import {
  IOptions,
  IQuestionAttachment,
  IQuestions,
  IQuiz,
} from '../interfaces/IQuiz'

export class Quiz implements IQuiz {
  constructor(
    public name: string,
    public note_before: string,
    public note_after: string,
    public published: boolean,
    public questions: IQuestions[],
    public course_id: string,
    public course_content_id: string,
    public deadline: string | null,
    public time_limit: number | null, // time limit in minutes
    public no_of_tries: number, // time limit in minutes
    public show_result: boolean | null,
    public created_at: string,
    public enable_accessible_on_homepage: boolean,
  ) {}
}

export class Question implements IQuestions {
  constructor(
    public question: string,
    public answer: string,
    // public userAnswer:string,
    public teacher_comment: string,
    public type: Number = 1,
    public options: IOptions[],
    public question_attachments: IQuestionAttachment[],
  ) {}
  _id?: string | undefined
}
